/**
 * Narative Slider
 */

// narative slider
export function narative_slider() {

    let narativeContentWidth;
    let narativeContent;
    const animationDuration = 2000;

    document.addEventListener('DOMContentLoaded', function () {
      narativeContent = document.querySelector('.narative-content');
      updateSliderWidth(); // 初回実行

      // 左ボタンにクリックイベントを追加
      const prevButton = document.querySelector('.slide-button-prev');
      prevButton.addEventListener('click', function () {
        scrollSlider(-1);
      });

      // 右ボタンにクリックイベントを追加
      const nextButton = document.querySelector('.slide-button-next');
      nextButton.addEventListener('click', function () {
        scrollSlider(1);
      });
    });

    window.addEventListener('resize', function () {
      updateSliderWidth(); // ウィンドウサイズ変更時に実行
    });

    function updateSliderWidth() {
      // console.log({narativeContent});
      if (!narativeContent) {
        console.error("narativeContent is undefined or null");
        return NaN;  // ダミーの値を返すか、エラー処理に応じて適切な値を返す
      }

      const narativeContentInner = document.querySelector('.narative-content__inner');
      const narativeSliderInner = document.querySelector('.p-narative-slider__inner');
      narativeContentWidth = narativeContent.offsetWidth;
      // console.log({narativeContentWidth});

      if (isNaN(narativeContentWidth)) {
        console.error("narativeContentWidth is NaN");
        return NaN;
      }

      narativeContentInner.scrollLeft = 0;

      return narativeContentWidth; // 計算した値を戻り値として返す
    }

    // getScrollLeft関数を定義
    // function getScrollLeft(narativeContentInner) {
    //   if (getComputedStyle(narativeContentInner).flexDirection === 'row-reverse') {
    //     return -narativeContentInner.scrollLeft; // Safari向けに負のscrollLeftを返す
    //   } else {
    //     return narativeContentInner.scrollLeft; // 通常のブラウザ向け
    //   }
    // }

    function scrollSlider(direction) {
      const scrollAmount = direction * (narativeContentWidth / 3 * 2);
      // console.log({narativeContentWidth});
      // console.log({ scrollAmount });

      const narativeContentInner = document.querySelector('.narative-content__inner');
      // let currentScrollLeft = getScrollLeft(narativeContentInner);  // Safari対応のスクロール取得
      const currentScrollLeft = narativeContentInner.scrollLeft; // 右からの距離
      let newScrollLeft = currentScrollLeft + scrollAmount; // 右からの距離にスクロール量を足したもの
      const scrollWidth = narativeContentInner.scrollWidth; // コンテンツ領域の幅
      const clientWidth = narativeContentInner.clientWidth; // 表示領域の幅
      const maxScrollLeft = scrollWidth - clientWidth; // スクロール領域の幅

      // スクロール範囲外に出ないように調整
      if (newScrollLeft > maxScrollLeft) {
        newScrollLeft = maxScrollLeft;
      // } else if (newScrollLeft > 0) {
      } else if (newScrollLeft > 0) {
        newScrollLeft = 0;
      }

      // アニメーションを使用してスムーズにスクロール
      const startTime = performance.now();

      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }

      function step(timestamp) {
        const progress = Math.min((timestamp - startTime) / animationDuration, 1);
        const easedProgress = easeInOutQuad(progress);
        narativeContentInner.scrollLeft = currentScrollLeft + easedProgress * (newScrollLeft - currentScrollLeft);

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }
      requestAnimationFrame(step);

      const currentScrollRight = (currentScrollLeft * -1) + (scrollAmount * -1) + clientWidth;
      // if (newScrollLeft === maxScrollLeft) {
      //   document.querySelector('.slide-button-next').setAttribute('aria-disabled', "true");
      // } else {
      //   document.querySelector('.slide-button-next').setAttribute('aria-disabled', "false");
      // }

      // if (newScrollLeft === 0) {
      //   document.querySelector('.slide-button-prev').setAttribute('aria-disabled', "true");
      // } else {
      //   document.querySelector('.slide-button-prev').setAttribute('aria-disabled', "false");
      // }
      if (currentScrollRight >= scrollWidth) {
        document.querySelector('.slide-button-prev').setAttribute('aria-disabled', "true");
        document.querySelector('.slide-button-next').setAttribute('aria-disabled', "false");
      } else if (newScrollLeft >= 0) {
        document.querySelector('.slide-button-prev').setAttribute('aria-disabled', "false");
        document.querySelector('.slide-button-next').setAttribute('aria-disabled', "true");
      } else {
        document.querySelector('.slide-button-prev').setAttribute('aria-disabled', "false");
        document.querySelector('.slide-button-next').setAttribute('aria-disabled', "false");
      }
    }


}
